import { Routes, Route } from "react-router";
import Organizations from '../pages/admin/Organizations';
import O365Licenses from '../pages/admin/O365/O365Licenses';
import ESET from '../pages/admin/ESET/ESET';
import O365Users from '../pages/admin/O365/O365Users';
import O365Dashboard from '../pages/admin/O365/O365Dashboard';
import EsetLicenses from '../pages/admin/ESET/EsetLicenses';
import { Box } from '@mui/material';
import VBO from '../pages/admin/VBO/VBO';
import VBO365Licenses from '../pages/admin/VBO/VBO365Licenses';
import VBO365Users from '../pages/admin/VBO/VBO365Users';
import EsetDevices from '../pages/admin/ESET/EsetDevices';
import SignIn from '../pages/admin/Authentification/SignIn';
import HistoryLog from '../pages/admin/HistoryLog';
import Domain from '../pages/admin/Domain';
import Centreon from '../pages/admin/CENTREON/Centreon';
import Contrats from '../pages/admin/Contrats';
import Quotes from '../pages/admin/Administratif/Quotes';
import Tickets from '../pages/admin/Tickets/Tickets';
import NotFound from '../pages/admin/NotFound';
import ContratDetails from '../pages/admin/ContratDetails';
import Signitic from '../pages/admin/Signitic/Signitic';
import QuoteSign from '../pages/admin/Administratif/QuoteSign';
import ContratMatrix from '../pages/admin/ContratMatrix';
import OAuthSuccess from '../pages/admin/OAuthSuccess';
import ImportMain from '../pages/admin/Import/ImportMain';
import Home from '../pages/admin/Home';
import Users from "../pages/admin/Users";
import Products from "../pages/admin/Products";
import Mc3Products from "../pages/admin/MC3Cloud/MC3Product";
import TimeEntryERM from "../pages/admin/Tickets/TimeEntryERM";
import IK from "../pages/admin/Tickets/IK";

function MainViewAdmin({ data }) {
  return (
    <Box sx={{ width: '100%',  }}>
    <Routes>
        <Route path="organizations">
          <Route index element={<Organizations />} />
          <Route path="users" element={<Users />} />
        </Route>
        
        <Route path="home" element={<Home />} />  
        <Route path="products" element={<Products />} />  
        <Route path="mc3cloud/products" element={<Mc3Products />} />  

        <Route path="o365" element={<O365Dashboard  />} />  
        <Route path="o365/licenses" element={<O365Licenses  />} />  
        <Route path="o365/users" element={<O365Users  />} /> 

        <Route path="eset" element={<ESET  />} />  
        <Route path="eset/licenses" element={<EsetLicenses  />} />  
        <Route path="eset/devices" element={<EsetDevices  />} />  

        <Route path="history" element={<HistoryLog  />} /> 

        <Route path="vbo365" element={<VBO  />} />  
        <Route path="vbo365/licenses" element={<VBO365Licenses  />} />  
        <Route path="vbo365/users" element={<VBO365Users  />} />  

        <Route path="domain" element={<Domain  />} />  
        <Route path="import" element={<ImportMain  />} />  
        <Route path="tickets" element={<Tickets  />} />  
        <Route path="tickets/timeEntry" element={<TimeEntryERM  />} />  
        <Route path="tickets/ik" element={<IK  />} />  

        <Route path="centreon" element={<Centreon  />} />  
        {/* <Route path="contrats" element={<Contrats  />} />   */}
        {/* <Route path="contrats/:id" element={<ContratDetails  />} />   */}
        <Route path="easyredmine" element={<Tickets  />} />  

        <Route path="auth" element={<SignIn />} />  
        <Route path="quotes" element={<Quotes />} />  
        <Route path="*" element={<NotFound />} />

        <Route path="quotes" >
          <Route index element={<Quotes />} />
          {/* <Route path=":id" element={<Quotes />} />   */}
          <Route path="form" element={<QuoteSign />} />  
        </Route>



         <Route path="contrats">
          <Route index element={<Contrats />} />
          <Route path=":id" element={<ContratDetails />} />
          <Route path="matrix" element={<ContratMatrix />} />
        </Route>

        <Route path="signitic" element={<Signitic />} />

        {/* <Route path="eset/devices" element={<ESETDevices />} />   */}
    </Routes>
    </Box>
  )
}

export default MainViewAdmin